import { Component, HostListener } from '@angular/core';
import { User } from 'src/app/models/user';
import { GroupsService } from 'src/app/services/groups.service';
import { LoginService } from 'src/app/services/login.service';
import { SettingsService } from 'src/app/services/settings.service';
import { UserService } from 'src/app/services/user.service';
import { first } from 'rxjs/operators';
import moment from 'moment';
import * as _ from "lodash"
import { CommonService } from 'src/app/services/common.service';
import { SocketService } from 'src/app/services/socket.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PaginationComponent } from 'src/app/helpers/pagination/pagination.component';
import { SortPipe } from 'src/app/sort.pipe';
import { SearchPipe } from 'src/app/search.pipe';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, PaginationComponent, SortPipe, SearchPipe, NgxPaginationModule]
})
export class GroupsComponent {
  sortField: string = 'status';
  sortDirection: string = 'asc';
  usersShow: boolean = false;
  devicesShow: boolean = false;
  activeTab: boolean = false;
  currentUser: User
  groups: any = [];
  activeGroups = 0;
  readyGroups = 0;
  pendingGroups = 0;
  page = 1;
  devicesPage = 1;
  usersPage = 1;
  numberBar: any = {};
  durationBar: any = {};
  user: any;
  users = [];
  searchText: any;
  deviceSearchText: any;
  userSearchText: any;
  usersByEmail: any = {};
  devices = [];
  devicesBySerial: any = {};
  groupsById = {};
  groupsEnv: any = {};
  scopeGroupsEnv = {};
  groupUserToAdd: any = {};
  p: number = 1;
  groupData: any;
  activeGroupId: number | null = null;

  sortparam: any;
  filteredGroups: any = {};
  groupPageSize: any;
  groupDevicesPageSize: any;
  groupUsersPageSize: any;
  showMenu: Boolean = false;
  showDevice: Boolean = false;
  showUser: Boolean = false;
  scope: any;
  userFields =
    'email,' +
    'name,' +
    'privilege';
  deviceFields =
    'serial,' +
    'version,' +
    'manufacturer,' +
    'marketName,' +
    'sdk,' +
    'display.width,' +
    'display.height,' +
    'model';
  itemsPerPageOptions = [
    { name: '1', value: 1 }
    , { name: '5', value: 5 }
    , { name: '10', value: 10 }
    , { name: '20', value: 20 }
    , { name: '50', value: 50 }
    , { name: '100', value: 100 }
    , { name: '200', value: 200 }
    , { name: '500', value: 500 }
    , { name: '1000', value: 1000 }
    , { name: '*', value: 0 }
  ];
  defaultGroupData = {
    columns: [
      { name: 'Status', selected: true, sort: 'none' }
      , { name: 'Name', selected: true, sort: 'sort-asc' }
      , { name: 'Identifier', selected: false, sort: 'none' }
      , { name: 'Owner', selected: true, sort: 'none' }
      , { name: 'Devices', selected: true, sort: 'none' }
      , { name: 'Users', selected: true, sort: 'none' }
      , { name: 'Class', selected: true, sort: 'none' }
      , { name: 'Repetitions', selected: false, sort: 'none' }
      , { name: 'Duration', selected: true, sort: 'none' }
      , { name: 'Starting Date', selected: true, sort: 'none' }
      , { name: 'Expiration Date', selected: true, sort: 'none' }
    ]
    , sort: { index: 1, reverse: false }
  }
  groupColumns = [
    { name: 'Status', property: 'status' }
    , { name: 'Name', property: 'name' }
    , { name: 'Identifier', property: 'id' }
    , { name: 'Owner', property: 'owner.name' }
    , { name: 'Devices', property: 'devices.length' }
    , { name: 'Users', property: 'users.length' }
    , { name: 'Class', property: 'class' }
    , { name: 'Repetitions', property: 'repetitions' }
    , { name: 'Duration', property: 'duration' }
    , { name: 'Starting Date', property: 'startTime' }
    , { name: 'Expiration Date', property: 'stopTime' }
  ]

  constructor(private groupsService: GroupsService, private userService: UserService,
    private loginService: LoginService, private settingsService: SettingsService,
    private commonService: CommonService, private socket: SocketService) {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);
  }

  @HostListener('document:click', ['$event']) onDocumentClick(event) {

    this.activeTab = false;
    this.activeGroupId = null;
    this.showMenu = false;
    this.showDevice = false;
    event.stopPropagation()
  }

  ngOnInit() {
    this.resetData();
    this.groupsService.getGroups().pipe(first()).subscribe((response: any) => {
      if (response.success || response.success == "true") {

        response.groups.forEach(data => {

          this.addGroup(data, -1);
        })
      }
    })

    this.userService.getUser().pipe(first()).subscribe((response: any) => {
      this.user = response.user
      this.updateQuotaBars()
    })

    this.userService.getUsers(this.userFields).pipe(first()).subscribe((response: any) => {
      if (response.success || response.success == "true") {
        response.users.forEach(data => {

          this.addUser(data, -1);
        })
      }
    })

    // this.userService.getOboeUsers(this.userFields, function(user) {this.addUser(user, -1)}).pipe(first()).subscribe((response:any) => {
    //   this.addUser(this.user, -1)
    // })

    // this.socket.socket.on('user.settings.devices.created', function(event:any, message:any) {
    //   this.addDevice(message.device, message.timeStamp)
    // })

    // this.socket.socket.on('user.settings.devices.deleted', function(event, message) {
    //   this.deleteDevice(message.device.serial, message.timeStamp)
    // })

    // this.socket.socket.on('user.settings.devices.updated', function(event, message) {
    //   this.updateDevice(message.device, message.timeStamp)
    // })

    // this.socket.socket.on('user.view.groups.created', function(event, message) {
    //   this.addGroup(message.group, message.timeStamp)
    // })

    // this.socket.socket.on('user.view.groups.deleted', function(event, message) {
    //   this.deleteGroup(message.group.id, message.timeStamp)
    // })

    // this.socket.socket.on('user.view.groups.updated', function(event, message) {
    //   if (this.commonService.isExisting(this.groupsById[message.group.id])) {
    //     if (message.group.users.indexOf(this.currentUser.email) < 0) {
    //       this.deleteGroup(message.group.id, message.timeStamp)
    //     }
    //     else {
    //       this.updateStateStats(this.groups[this.groupsById[message.group.id].index], message.group)
    //       this.updateGroupDevices(message.group, message.isAddedDevice, message.devices, message.timeStamp)
    //       this.updateGroupUsers(message.group, message.isAddedUser, message.users, message.timeStamp)
    //       this.updateGroup(message.group, message.timeStamp)
    //       this.updateGroupExtraProperties(this.groups[this.groupsById[message.group.id].index])
    //     }
    //   }
    //   else {
    //     this.addGroup(message.group, message.timeStamp)
    //   }
    // })

    // this.socket.socket.on('user.settings.users.created', function(event, message) {
    //   this.addUser(message.user, message.timeStamp)
    // })

    // this.socket.socket.on('user.settings.users.deleted', function(event, message) {
    //   this.deleteUser(message.user.email, message.timeStamp)
    // })

    // this.socket.socket.on('user.view.users.updated', function(event, message) {
    //   if (message.user.email === this.user.email) {
    //     this.user = message.user
    //     this.updateQuotaBars()
    //   }
    // })

  }

  //for sorting the table columns
  sortBy(data, column) {
    const index = this.getIndex(data.columns, column.name, 'name');

    if (index !== data.sort.index) {
      data.sort.reverse = false;
      column.sort = 'sort-asc';
      data.columns[data.sort.index].sort = 'none';
      data.sort.index = index;
    } else {
      data.sort.reverse = !data.sort.reverse;
      column.sort = column.sort === 'sort-asc' ? 'sort-desc' : 'sort-asc';
    }
    switch (column.name) {
      case "Status":
        this.sortField = "status";
        break;
      case "Name":
        this.sortField = "name";
        break;
      case "Identifier":
        this.sortField = "id";
        break;
      case "Owner":
        this.sortField = "owner";
        break;
      case "Devices":
        this.sortField = "devices";
        break;
      case "Users":
        this.sortField = "users";
        break;
      case "Class":
        this.sortField = "class";
        break;
      case "Repetitions":
        this.sortField = "repetitions";
        break;
      case "Durations":
        this.sortField = "duration";
        break;
      case "Starting Date":
        this.sortField = "startTime";
        break;
      case "Expiration Date":
        this.sortField = "stopTime";
        break;
    }
    this.sortDirection = column.sort === 'sort-asc' ? 'asc' : 'desc';

  }
  getIndex(array, value, property) {
    for (let i in array) {
      if (array[i][property] === value) {
        return i
      }
    }
    return -1
  }

  onSearch(searchData: any) {
    this.searchText = searchData;
    this.page = 1;
  }

  onItemPerPageChange(changedItemPerPage: any) {
    this.groupPageSize = changedItemPerPage;
    this.page = 1;
  }

  onNextPageChange(nextPage: number) {
    this.page = nextPage;
  }

  //for devices pagination
  onSearchDevice(searchData: any) {
    this.deviceSearchText = searchData;
    this.devicesPage = 1;
  }

  onDevicesItemPerPageChange(changedItemPerPage: any) {
    this.groupDevicesPageSize = changedItemPerPage;
    this.devicesPage = 1;
  }

  onNextPageChangeDevices(nextPage: number) {
    this.devicesPage = nextPage;
  }

  onSearchUser(searchData: any) {
    this.userSearchText = searchData;
    this.usersPage = 1;
  }

  onUsersItemPerPageChange(changedItemPerPage: any) {
    this.groupUsersPageSize = changedItemPerPage;
    this.usersPage = 1;
  }

  onNextPageChangeUsers(nextPage: number) {
    this.usersPage = nextPage;
  }

  showSubMenu() {
    if (this.showMenu) {
      this.showMenu = false
    } else {
      this.showMenu = true
    }
  }

  incrStateStats(group: any, incr: any) {
    if (group.isActive) {
      this.activeGroups = this.activeGroups + incr
    }
    else if (group.state === 'pending') {
      this.pendingGroups += incr
    }
    this.readyGroups = this.groups.length - this.activeGroups - this.pendingGroups;
  }

  updateStateStats(oldGroup: any, newGroup: any) {
    if (oldGroup === null) {
      this.incrStateStats(newGroup, 1)
    }
    else if (newGroup === null) {
      this.incrStateStats(oldGroup, -1)
    }
    else {
      if (newGroup.isActive && !oldGroup.isActive) {
        this.incrStateStats(newGroup, 1)
      }
      else if (!newGroup.isActive && oldGroup.isActive) {
        this.incrStateStats(oldGroup, -1)
      }
      else if (newGroup.state === 'ready' && oldGroup.state === 'pending') {
        this.incrStateStats(oldGroup, -1)
      }
    }
  }

  updateGroupExtraProperties(group: any) {
    let status: any = { pending: 'Pending', waiting: 'Waiting', ready: 'Ready' }

    group.status = group.isActive ? 'Active' : status[group.state]
    group.startTime = moment(group.dates[0].start).format(this.settingsService.get('dateFormat'));
    //filter('date')(group.dates[0].start, this.settingService.get('dateFormat'))
    group.stopTime = moment(group.dates[0].stop).format(this.settingsService.get('dateFormat'));
    //filter('date')(group.dates[0].stop, this.settingService.get('dateFormat'))

  }

  updateQuotaBar(bar: any, consumed: any, allocated: any) {
    bar.value = (consumed / allocated) * 100 | 0
    if (bar.value < 25) {
      bar.type = 'success'
    }
    else if (bar.value < 50) {
      bar.type = 'info'
    }
    else if (bar.value < 75) {
      bar.type = 'warning'
    }
    else {
      bar.type = 'danger'
    }
  }

  updateQuotaBars() {
    this.updateQuotaBar(
      this.numberBar
      , this.user.groups.quotas.consumed.number
      , this.user.groups.quotas.allocated.number
    )
    this.updateQuotaBar(
      this.durationBar
      , this.user.groups.quotas.consumed.duration
      , this.user.groups.quotas.allocated.duration
    )
  }

  addGroup(group: any, timeStamp: any) {
    if (this.commonService.add(this.groups, this.groupsById, group, 'id', timeStamp)) {
      this.scopeGroupsEnv[group.id] = {
        devices: []
        , users: []
      }
      this.groupsEnv[group.id] = {
        devicesBySerial: {}
        , usersByEmail: {}
      }
      this.updateStateStats(null, group)
      this.updateGroupExtraProperties(group)
      return group
    }
    return null
  }

  updateGroup(group: any, timeStamp: any) {
    return this.commonService.update(this.groups, this.groupsById, group, 'id', timeStamp, null);
  }

  deleteGroup(id: any, timeStamp: any) {
    const group = this.commonService.delete(this.groups, this.groupsById, id, timeStamp);

    if (group) {
      this.updateStateStats(group, null)
      delete this.scopeGroupsEnv[group.id]
      delete this.groupsEnv[group.id]
    }
    return group
  }

  addUser(user: any, timeStamp: any) {
    if (this.commonService.add(this.users, this.usersByEmail, user, 'email', timeStamp) && typeof this.groupUserToAdd[user.email] !== 'undefined') {
      this.addGroupUser(this.groupUserToAdd[user.email].id, user.email, this.groupUserToAdd[user.email].timeStamp);
      delete this.groupUserToAdd[user.email]
    }
  }

  deleteUser(email: any, timeStamp: any) {
    return this.commonService.delete(this.users, this.usersByEmail, email, timeStamp)
  }

  addDevice(device: any, timeStamp: any) {
    return this.commonService.add(this.devices, this.devicesBySerial, device, 'serial', timeStamp)
  }

  updateDevice(device: any, timeStamp: any) {
    return this.commonService.update(this.devices, this.devicesBySerial, device, 'serial', timeStamp, null)
  }

  deleteDevice(serial: any, timeStamp: any) {
    return this.commonService.delete(this.devices, this.devicesBySerial, serial, timeStamp)
  }

  addGroupUser(id: any, email: any, timeStamp: any) {
    if (this.commonService.isExisting(this.usersByEmail[email])) {
      this.commonService.add(this.scopeGroupsEnv[id].users, this.groupsEnv[id].usersByEmail, this.users[this.usersByEmail[email].index], 'email', timeStamp)
    }
    else {
      this.groupUserToAdd[email] = { id: id, timeStamp: timeStamp }
    }
  }

  deleteGroupUser(id: any, email: any, timeStamp: any) {
    this.commonService.delete(this.scopeGroupsEnv[id].users, this.groupsEnv[id].usersByEmail, email, timeStamp)
  }

  addGroupDevice(id: any, serial: any, timeStamp: any) {
    if (this.commonService.isExisting(this.devicesBySerial[serial])) {
      this.commonService.add(this.scopeGroupsEnv[id].devices, this.groupsEnv[id].devicesBySerial
        , this.devices[this.devicesBySerial[serial].index], 'serial', timeStamp)
    }
    else {
      this.groupsService.getGroupDevice(id, serial, this.deviceFields).pipe(first()).subscribe((response: any) => {
        if (this.addDevice(response.data.device, timeStamp)) {
          this.commonService.add(
            this.scopeGroupsEnv[id].devices
            , this.groupsEnv[id].devicesBySerial
            , this.devices[this.devicesBySerial[serial].index]
            , 'serial'
            , timeStamp)
        }
      })
    }
  }

  deleteGroupDevice(id, serial, timeStamp) {
    this.commonService.delete(
      this.scopeGroupsEnv[id].devices
      , this.groupsEnv[id].devicesBySerial
      , serial
      , timeStamp)
  }

  updateGroupDevices(group, isAddedDevice, devices, timeStamp) {
    if (devices.length) {
      if (isAddedDevice) {
        devices.forEach(function (serial) {
          this.addGroupDevice(group.id, serial, timeStamp)
        })
      }
      else {
        devices.forEach(function (serial) {
          this.deleteGroupDevice(group.id, serial, timeStamp)
        })
      }
    }
  }

  updateGroupUsers(group, isAddedUser, users, timeStamp) {
    if (users.length) {
      if (isAddedUser) {
        users.forEach(function (email) {
          this.addGroupUser(group.id, email, timeStamp)
        })
      }
      else {
        users.forEach(function (email) {
          this.deleteGroupUser(group.id, email, timeStamp)
        })
      }
    }
  }

  searchGroups() {
    this.p = 1;
  }

  mail() {
    window.location.href = 'mailto:';
  }
  mailToGroupOwners() {
    // this.commonService.copyToClipboard(_.uniq(groups.map(function(group) {
    //   return group.owner.email
    // }))
    // .join(this.settingsService.get('emailSeparator')))
    // .url('mailto:?body=*** Paste the email addresses from the clipboard! ***')
    let mail = 'mailto:admin@apmosys.com';
    window.location.href = mail;
  }

  mailToGroupUsers(group, users) {

    let mail_id = ""
    users.forEach(user => {
      if (mail_id != "") {
        user.email = this.settingsService.get('emailSeparator') + user.email;
      }
      mail_id = mail_id + user.email;
    });


    window.location.href = "mailto:" + mail_id + "?body=*** Paste the email addresses from the clipboard! ***"
    // group unused actually..
    // this.commonService.copyToClipboard(users.map(function(user) {
    //   return user.email
    // })
    // .join(this.settingsService.get('emailSeparator')))
    // .url('mailto:?body=*** Paste the email addresses from the clipboard! ***')
  }

  getTooltip(objects) {
    let tooltip = ''

    objects.forEach(function (object) {
      tooltip += object + '\n'
    })
    return tooltip
  }

  resetData = function () {
    this.groupData = JSON.parse(JSON.stringify(this.defaultGroupData))

  }

  initGroupUsers(group) {
    if (this.activeGroupId === group.id) {
      this.activeGroupId = null;  // Hide the dropdown if the same group is clicked
    } else {
      this.activeGroupId = group.id;  // Show the dropdown for the clicked group
    }
    // if(group.id == data.id){
    if (typeof this.scopeGroupsEnv[group.id].userCurrentPage === 'undefined') {
      this.scopeGroupsEnv[group.id].userCurrentPage = 1
      this.scopeGroupsEnv[group.id].userItemsPerPage = this.itemsPerPageOptions[1]
    }
    group.users.forEach(email => {
      this.addGroupUser(group.id, email, -1)
    })
    this.showUser = !this.showUser;
    // this.showUser =true
  }



  // if (typeof this.scopeGroupsEnv[group.id].userCurrentPage === 'undefined') {
  //   this.scopeGroupsEnv[group.id].userCurrentPage = 1
  //   this.scopeGroupsEnv[group.id].userItemsPerPage = this.itemsPerPageOptions[1]
  // }
  // group.users.forEach(email => {
  //   this.addGroupUser(group.id, email, -1)
  // })



  initGroupDevices(group) {


    if (this.activeGroupId === group.id) {
      this.activeGroupId = null;  // Hide the dropdown if the same group is clicked
    } else {
      this.activeGroupId = group.id;  // Show the dropdown for the clicked group
    }



    if (!this.showDevice) {

      if (typeof this.scopeGroupsEnv[group.id].deviceCurrentPage === 'undefined') {

        this.scopeGroupsEnv[group.id].deviceCurrentPage = 1
        this.scopeGroupsEnv[group.id].deviceItemsPerPage = this.itemsPerPageOptions[1]
      }
      this.groupsService.getGroupDevices(group.id, false, this.deviceFields).pipe(first()).subscribe((response: any) => {


        if (response.success || response.success == "true") {
          response.devices.forEach(device => {
            this.addDevice(device, -1)
            this.addGroupDevice(group.id, device.serial, -1)
          });
        }
      })
    }
    this.showDevice = !this.showDevice;
    // this.groupsService.getOboeGroupDevices(group.id, false, this.deviceFields, function(device) {
    //   this.addDevice(device, -1)
    //   this.addGroupDevice(group.id, device.serial, -1)
    // })
    // .done(function() {
    //   this.digest()
    // })
  }

  //pagination 	
  // handlePageChange(event: any) {
  //   this.page = event.pageIndex + 1;       // MatPaginator 0-based to 1-based
  //   this.itemsPerPage = event.pageSize;    // Keep items per page updated
  //   this.nextPageChange.emit(this.page);   // Notify parent or service
  // }

  // sortBy(groupData, column) {

  //   let res = this.commonService.sortBy(groupData, column);
  //   return res;
  // }

  getClassName(className: any) {
    return this.commonService.getClassName(className);
  }

  getDuration(duration: any) {
    return this.commonService.getDuration(duration);
  }

}